import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {AssetProperty} from "../assets/asset.model";

@Injectable({
    providedIn: 'root'
})
export class UploadStateService {

    mode$: BehaviorSubject<UploadMode> = new BehaviorSubject<UploadMode>('inactive');
    visibleProperties$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    lastChangedMasterProperty$: BehaviorSubject<AssetProperty | null> = new BehaviorSubject<AssetProperty | null>(null);

    constructor() {
    }

    set mode(mode: UploadMode) {
        this.mode$.next(mode);
    }

    get mode(): UploadMode {
        return this.mode$.value;
    }

    addVisibleProperty(property: string) {
        this.visibleProperties$.next([...this.visibleProperties$.value, property]);
    }

    removeVisibleProperty(property: string) {
        this.visibleProperties$.next(this.visibleProperties$.value.filter(p => p !== property));
    }

    set visibleProperties(properties: string[]) {
        this.visibleProperties$.next(properties);
    }

    get visibleProperties(): string[] {
        return this.visibleProperties$.value;
    }

}

export type UploadMode = 'new' | 'edit' | 'inactive';
